import type { loader } from './AppointmentsDrilldown.data.ts';

import * as React from 'react';
import { useLoaderData, useSearchParams } from 'react-router';

import { FiltersPanel } from '#components/FiltersPanel/FiltersPanel.tsx';
import { Address } from '#routes/Home/Filters/Address.tsx';
import { AppointmentTypes } from '#routes/Home/Filters/AppointmentTypes.tsx';
import { BookingChannel } from '#routes/Home/Filters/BookingChannel.tsx';
import { DateRange } from '#routes/Home/Filters/DateRange.tsx';
import { Provider } from '#routes/Home/Filters/Provider.tsx';

export function AppointmentsFiltersPanel() {
  const data = useLoaderData<Awaited<ReturnType<typeof loader>>>();
  const [, setSearchParams] = useSearchParams();
  const [resetKey, setResetKey] = React.useState(0);

  function handleRemoveAll() {
    setSearchParams((sp) => {
      // Only remove filters used in Appointments panel
      sp.delete('from'); // Date range start
      sp.delete('to'); // Date range end
      sp.delete('pId'); // Provider IDs
      sp.delete('bat'); // Base Appointment Types
      sp.delete('atId'); // Appointment Type IDs
      sp.delete('aId'); // Address IDs
      sp.delete('bcId'); // Booking Channel IDs

      // Reset to first page after removing filters
      sp.set('page', '1');
      return sp;
    });

    // Delay reset key increment to ensure URL has updated
    setTimeout(() => {
      setResetKey((prev) => prev + 1);
    }, 0);
  }

  return (
    <FiltersPanel onRemoveAll={handleRemoveAll}>
      <DateRange key={`date-${resetKey}`} defaultValue={[data.from, data.to]} />
      <Provider key={`provider-${resetKey}`} defaultValue={data.providerIds} />
      <AppointmentTypes
        key={`appointments-${resetKey}`}
        defaultValue={{
          baseAppointmentTypes: data.baseAppointmentTypes,
          appointmentTypeIds: data.appointmentTypeIds,
        }}
      />
      <Address key={`address-${resetKey}`} defaultValue={data.addressIds} />
      <BookingChannel key={`booking-${resetKey}`} defaultValue={data.bookingChannelIds} />
    </FiltersPanel>
  );
}
